'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TeachingPopoverCarouselNav", {
    enumerable: true,
    get: function() {
        return TeachingPopoverCarouselNav;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useTeachingPopoverCarouselNav = require("./useTeachingPopoverCarouselNav");
const _renderTeachingPopoverCarouselNav = require("./renderTeachingPopoverCarouselNav");
const _useTeachingPopoverCarouselNavStylesstyles = require("./useTeachingPopoverCarouselNavStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const TeachingPopoverCarouselNav = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useTeachingPopoverCarouselNav.useTeachingPopoverCarouselNav_unstable)(props, ref);
    (0, _useTeachingPopoverCarouselNavStylesstyles.useTeachingPopoverCarouselNavStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useTeachingPopoverCarouselNavStyles_unstable')(state);
    return (0, _renderTeachingPopoverCarouselNav.renderTeachingPopoverCarouselNav_unstable)(state);
});
TeachingPopoverCarouselNav.displayName = 'TeachingPopoverCarouselNav';
